// 订单管理
export default [
  {
    path: "/orderManage",
    name: "orderManage",
    meta: { title: "订单管理" },
    component: () => import("../views/orderManage/index.vue"),
    children: [
      {
        path: "/orderManage/reserveOrder",
        name: "reserveOrder",
        meta: { title: "预约订单", isMenu: true },
        component: () => import("../views/orderManage/reserveOrder.vue"),
      },
      // {
      //   path: "/orderManage/experienceProject",
      //   name: "experienceProject",
      //   meta: { title: "体验项目订单", isMenu: true },
      //   component: () => import("../views/orderManage/experienceProject.vue"),
      // },
      // {
      //   path: "/orderManage/formalProject",
      //   name: "formalProject",
      //   meta: { title: "正式项目订单", isMenu: true },
      //   component: () => import("../views/orderManage/formalProject.vue"),
      // },
      {
        path: "/orderManage/detail/reserveOrderDet",
        name: "reserveOrderDet",
        meta: { title: "预约订单详情" },
        component: () => import("../views/orderManage/detail/reserveOrderDet.vue"),
      },
      {
        path: "/orderManage/productOrder",
        meta: { title: "商品订单", isMenu: true }
        // component: () => import("../views/orderManage/productOrder.vue"),
      },
      // 商品订单  二级菜单
      {
        path: '/orderManage/productOrder/orderList',
        name: "orderList",
        meta: { title: '线上订单', isMenu: true },
        component: () => import('../views/orderManage/orderList.vue'),
      },
      {
        path: '/orderManage/productOrder/offlineOrder',
        name: "offlineOrder",
        meta: { title: '线下订单', isMenu: true },
        component: () => import('../views/orderManage/offlineOrder.vue'),
      },
      {
        path: '/orderManage/productOrder/afterSaleOrderList',
        name: "afterSaleOrderList",
        meta: { title: '售后订单', isMenu: true },
        component: () => import('../views/orderManage/afterSaleOrderList.vue'),
      },
      {
        path: "/orderManage/detail/orderListDet",
        name: "orderListDet",
        meta: { title: "线上订单详情" },
        component: () => import("../views/orderManage/detail/orderListDet.vue"),
      }, 
      {
        path: "/orderManage/detail/offlineOrderDet",
        name: "offlineOrderDet",
        meta: { title: "线下订单详情" },
        component: () => import("../views/orderManage/detail/offlineOrderDet.vue"),
      },
      {
        path: "/orderManage/detail/distributionDet",
        name: "distributionDet",
        meta: { title: "商品订单详情" },
        component: () => import("../views/orderManage/detail/distributionDet.vue"),
      },
      {
        path: "/orderManage/detail/afterSaleOrderDet",
        name: "afterSaleOrderDet",
        meta: { title: "商品售后订单详情" },
        component: () => import("../views/orderManage/detail/afterSaleOrderDet.vue"),
      },
    ],
  },
]
